import { useSelector } from 'react-redux';
import { useArtboardLayoutContext } from 'components/ArtboardLayout/context/ArtboardLayoutContext';
import { documents as documentsSelector } from 'containers/Documents/selectors';
import { artboardLayoutsBySectionId } from 'containers/Layouts/selectors';
import * as Models from 'models';
import { isGroupLayout } from 'utils/layouts/isGroupLayout';
import { isReusableLayout } from 'utils/reusableLayouts/isReusableLayout';

export const FALLBACK_ASSET_ID = 'ASSET-XXXXXXXX';

export const useFirstAssetNumberId = (): string => {
  const { sectionId, currentArtboardLayoutId } = useArtboardLayoutContext();
  const documents = useSelector(documentsSelector);
  const layoutsInSection = useSelector(artboardLayoutsBySectionId(sectionId));
  const layoutsWithPosition = layoutsInSection.map((layout, index) => ({ layout, position: index }));
  const currentLayout = layoutsWithPosition.find(({ layout }) => layout.get('id') === currentArtboardLayoutId);
  if (!currentLayout) {
    return FALLBACK_ASSET_ID;
  }
  if (isReusableLayout(currentLayout.layout, documents) || isGroupLayout(currentLayout.layout)) {
    return FALLBACK_ASSET_ID;
  }

  const firstReusableAssetAfterCurrentLayout = layoutsWithPosition.find(({ layout, position }) => {
    return (position > currentLayout.position) && (isReusableLayout(layout, documents) || isGroupLayout(layout));
  });

  if (!firstReusableAssetAfterCurrentLayout) {
    return FALLBACK_ASSET_ID;
  }

  const reusableAsset = documents.get(firstReusableAssetAfterCurrentLayout.layout.get('documentId')) as Models.DocumentMap | undefined;

  return reusableAsset?.get('number') ?? FALLBACK_ASSET_ID;
};
